$(function () {
  if (!customElements.get('global-product')) {
    // 创建弹窗根容器
    const createModalRoot = () => {
      const existingRoot = document.getElementById('global-modal__root');
      if (existingRoot) return existingRoot;

      const root = document.createElement('div');
      root.id = 'global-modal__root';
      root.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 500;
      `;
      document.body.appendChild(root);
      return root;
    };
    customElements.define(
      'global-product',
      class GlobalProduct extends HTMLElement {
        shopMoneyFormat = null;
        // 弹窗根容器
        static root = null;
        // 存储当前组件的弹窗元素
        productDetailModal = null;
        mobileClickStatus = false;
        // 获取或创建根容器
        static getRoot() {
          if (!this.root) {
            this.root = createModalRoot();
          }
          return this.root;
        }
        constructor() {
          super();
        }
        connectedCallback() {
          const _this = this;
          this.init();
          // 获取function_icon_wrapper
          const $functionIconWrapper = $(this).find('.function_icon_wrapper');
          const function_text_wrapper = $(this).find('.function_text_wrapper');
          const function_icon = $(this).find('.function_icon');

          const clearClickStatus = () => {
            this.mobileClickStatus = false;
            function_text_wrapper.css('opacity', 0).css('top', '0');
            $functionIconWrapper.each(function () {
              $(this).attr('data-click-status', 'false');
            });
            function_icon.removeClass('hover_icon');
          };
          $functionIconWrapper.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            // 判断屏幕宽度小于1200px
            if ($(window).width() <= 1200) {
              _this.mobileClickStatus = true;
              if ($(this).attr('data-click-status') === 'false') {
                function_text_wrapper.css('opacity', 0).css('top', '0');
                function_icon.removeClass('hover_icon');
                $functionIconWrapper.each(function () {
                  $(this).attr('data-click-status', 'false');
                });
                $(this).attr('data-click-status', 'true');
                $(this).find('.function_icon').addClass('hover_icon');
                $(this)
                  .find('.function_text_wrapper')
                  .addClass('block')
                  .removeClass('hidden')
                  .css('opacity', 1)
                  .css('top', '-12px');
              } else {
                clearClickStatus();
              }
            }
          });
          document.addEventListener('click', (e) => {
            if (this.mobileClickStatus) {
              clearClickStatus();
            }
          });
        }

        init() {
          const _this = this;
          const hoverWidth = $(this).find('.hover-width');
          hoverWidth.on('mouseenter', function () {
            if ($(this).find('.hover_text').is(':visible')) {
              $(this).css('width', 'auto');
              const autoWidth = $(this).width();
              $(this).css('width', '32px');
              setTimeout(() => {
                $(this).css('width', `${autoWidth}px`);
              }, 50);
            }
          });
          hoverWidth.on('mouseout', function () {
            if ($(this).find('.hover_text').is(':visible')) {
              setTimeout(() => {
                if (!$(this).is(':hover')) {
                  $(this).css('width', '32px');
                }
              }, 50);
            }
          });
          this.shopMoneyFormat = window.shopMoneyFormat;

          // 获取弹窗并移动到root
          const $productDetailModal = $(this).find('.product-detail-data-modal');
          if ($productDetailModal.length) {
            // 将弹窗移动到root节点
            const root = this.constructor.getRoot();
            $productDetailModal.appendTo(root);

            // 确保弹窗可以接收点击事件
            $productDetailModal.css('pointer-events', 'auto');

            // 保存移动后的弹窗引用
            this.productDetailModal = $productDetailModal;

            // 重新初始化product-detail-data-popup组件
            if (window.customElements) {
              window.customElements.upgrade(this.productDetailModal[0]);
            }
          }

          // 获取所有data-product-handle的元素
          const $productHandles = $(this).find('[data-product-handle]');

          $productHandles.on('click', function (event) {
            event.preventDefault();
            // 禁用浏览器滚动
            window.litime.disableScroll();

            if (_this.productDetailModal) {
              // 获取template标签下的内容
              if (_this.productDetailModal.find('template').length) {
                const templateContent = _this.productDetailModal.find('template').html();
                _this.productDetailModal.html(templateContent);
                // clone _this.productDetailModal
                const cloneModal = _this.productDetailModal.clone();
                console.log(cloneModal[0], 'cloneModal');
                // 删除_this.productDetailModal元素
                _this.productDetailModal.remove();
                const root = _this.constructor.getRoot();
                cloneModal.appendTo(root);
                _this.productDetailModal = $(cloneModal[0]);
              }
              // 修改选择器，直接选择弹窗本身
              _this.productDetailModal.addClass('flex').removeClass('hidden');
            }
          });

          const addCartButton = $(this).find('[data-first_variant_id]').find('[type="submit"]');
          addCartButton.on('click', function (event) {
            // 阻止默认事件
            event.preventDefault();
            // 获取index
            const index = $(_this).find('[data-first_variant_id]').find('[type="submit"]').index(this);
            const dataFirstVariantId = $(_this).find('[data-first_variant_id]').eq(index).data('first_variant_id');
            const skuCount = $(_this).find('[data-first_variant_id]').eq(index).data('sku-count');
            console.log(skuCount, 'skuCount');
            if (skuCount > 1) {
              window.litime.disableScroll();
              if (_this.productDetailModal) {
                // 获取template标签下的内容
                if (_this.productDetailModal.find('template').length) {
                  const templateContent = _this.productDetailModal.find('template').html();
                  _this.productDetailModal.html(templateContent);
                  // clone _this.productDetailModal
                  const cloneModal = _this.productDetailModal.clone();
                  console.log(cloneModal[0], 'cloneModal');
                  // 删除_this.productDetailModal元素
                  _this.productDetailModal.remove();
                  const root = _this.constructor.getRoot();
                  cloneModal.appendTo(root);
                  _this.productDetailModal = $(cloneModal[0]);
                }
                // 修改选择器，直接选择弹窗本身
                _this.productDetailModal.addClass('flex').removeClass('hidden');
              }
            } else {
              _this.addToCart(this, dataFirstVariantId, 1);
            }
          });
        }
        changeProductVariant(element) {
          $(element).addClass('product-variant_active');
          this.productVariantId = $(element).data('product-variant-id');
        }

        checkInventory(variantId, $modal, $input) {
          if (+this.productInventoryQuantity[variantId] <= 0) {
            $modal.find('.product-detail-popup_soldout').removeClass('hidden');
            $modal.find('.product-detail-popup_button').addClass('hidden');
            $input.attr('max', 1);
          } else {
            $modal.find('.product-detail-popup_soldout').addClass('hidden');
            $modal.find('.product-detail-popup_button').removeClass('hidden').addClass('flex');
            $input.attr('max', this.productInventoryQuantity[variantId]);
          }
        }

        addToCart(event, productId, quantity) {
          const _this = this;

          $(event).find('.rotate_icon').removeClass('hidden').addClass('flex');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [
                {
                  id: productId,
                  quantity,
                },
              ],
              sections: 'cart-drawer,cart-icon-bubble',
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              $(event).find('.rotate_icon').addClass('hidden').removeClass('flex');
              if (window.gtag) {
                gtag('event', 'conversion', { send_to: 'AW-11059876179/OfmnCMjGxIsYENOi4Zkp' });
              }
              if (data.status && data.status != 200) {
                window.litime.showToast('error', data.message);
              } else {
                if (window.location.href.includes('cart')) {
                  window.location.reload();
                  window.scrollTo(0, 0);
                } else {
                  // 使用 updateCartComponents 更新购物车
                  updateCartComponents(data);
                  // 打开购物车抽屉
                  const cartDrawer = document.querySelector('cart-drawer');
                  if (cartDrawer) {
                    cartDrawer.open();
                  }
                }
              }
            })
            .catch((error) => {
              $(event).find('.rotate_icon').addClass('hidden').removeClass('flex');
            });
        }

        destroy() {
          // 恢复浏览器滚动
          window.litime.enableScroll();

          if (this.productDetailModalSmallPictrueSwiper) {
            this.productDetailModalSmallPictrueSwiper.destroy();
          }
          if (this.productDetailModalBigPictrueSwiper) {
            this.productDetailModalBigPictrueSwiper.destroy();
          }

          // 移除时同时清理弹窗
          if (this.productDetailModal) {
            this.productDetailModal.remove();
            this.productDetailModal = null;
          }
        }

        disconnectedCallback() {
          this.destroy();
        }
      }
    );
  }
});
